module.exports = "<!--\r\n  gradeTests.html\r\n  Copyright © 2018 Xerox Corporation. All Rights Reserved. \r\n  \r\n  Copyright protection claimed includes all forms and matters of copyrightable material \r\n  and information now allowed by statutory or judicial law or hereinafter granted, \r\n  including without limitation, material generated from the software programs which \r\n  are displayed on the screen such as icons, screen display looks, etc.\r\n-->\r\n\r\n<scan>\r\n</scan>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/gradeTests/gradeTests.html
// module id = 453
// module chunks = 0